<template>
    <div>
      <common-dialog
        ref="dialog"
        width="900px"
        :show-save-button="$permission.canEdit()"
        unit="推广奖励设置"
        edit-title
        id-key="RecordId"
      
        form-label-width="125px"
       
      >
        <template slot="form">
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="奖励类型" prop="">
                <el-input placeholder="请填写奖励类型" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="isMB?24:12">
              <el-form-item label="奖励计数单位" prop="">
                <el-input placeholder="请填写奖励计数单位" clearable></el-input>
              </el-form-item>
            </el-col>
           
          </el-row>
         
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="奖励计数范围起始" prop="">
                <el-input placeholder="请填写奖励计数范围起始" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="isMB?24:12">
              <el-form-item label="奖励计数范围截止" prop="">
                <el-input placeholder="请填写奖励计数范围截止" clearable></el-input>
              </el-form-item>
            </el-col>
           
          </el-row>
         
          <el-row>
            
             <el-col :span="isMB?24:12">
              <el-form-item label="获得奖励金额" prop="">
                <el-input placeholder="请填写获得奖励金额" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="isMB?24:12" >
              <el-form-item label="状态" prop="">
                 <el-radio-group v-model="data.State">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
         
        </template>
        <template #footer v-if="!$permission.canEdit()">
           <el-button @click="close">关 闭</el-button>
      </template>
      </common-dialog>
    </div>
  </template>
  <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
 
  
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
    
    },
    data() {
      return {
       data: {
         
          State: 1,
        },
        isMB: this.$store.state.isMB,
        rules: {
         
        },
      };
    },
    methods: {
     
     
    },
  };
  </script>